import React, { useCallback, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { SyncKnowledgeBaseZendeskHelpCenterForm } from './SyncKnowledgeBaseZendeskHelpCenterForm';
import { IntegrationSyncIcon } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseIcons/CurrentKnowledgeBaseIcons';
import { INTEGRATION_NAMES_MAP } from 'src/utils/fileUtils';
import { SyncKnowledgeBaseWebsiteForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/SyncKnowledgeBaseIntegrationModal/SyncKnowledgeBaseWebsiteForm';
import { SyncKnowledgeBaseZendeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/SyncKnowledgeBaseIntegrationModal/SyncKnowledgeBaseZendeskTicketsForm';
import { SyncKnowledgeBaseFreshdeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/SyncKnowledgeBaseIntegrationModal/SyncKnowledgeBaseFreshdeskTicketsForm';

export const SyncKnowledgeBaseIntegrationModal = ({ disabled = false, item }) => {
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
  };

  const renderForm = useCallback(() => {
    switch (item.data.type) {
      case 'zendesk_helpcenter':
        return <SyncKnowledgeBaseZendeskHelpCenterForm close={close} item={item} />;
      case 'zendesk_tickets':
        return <SyncKnowledgeBaseZendeskTicketsForm close={close} item={item} />;
      case 'freshdesk_tickets':
        return <SyncKnowledgeBaseFreshdeskTicketsForm close={close} item={item} />;
      case 'web_scrapper':
        return <SyncKnowledgeBaseWebsiteForm close={close} item={item} />;
    }
  }, [item]);

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <button
          className={clsx(
            disabled && 'pointer-events-none opacity-20',
            'flex gap-2 opacity-30 hover:opacity-100 transition',
          )}
        >
          <IntegrationSyncIcon />
        </button>
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle>{INTEGRATION_NAMES_MAP[item.data.type]} Synchronization</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">{renderForm()}</div>
      </DialogContent>
    </Dialog>
  );
};
